import { render, staticRenderFns } from "./SitiosArqueologicos.vue?vue&type=template&id=8a03dd24&lang=pug"
import script from "./SitiosArqueologicos.vue?vue&type=script&lang=js"
export * from "./SitiosArqueologicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports